import React from 'react';
import c from 'classnames';

import { View } from '@uncinc/react-drupal-core';

const ParagraphAnnualReportThemesOverview = (props) => {
  const {
    entity,
    className,
  } = props;

  const classNames = c('Paragraph', 'ParagraphAnnualReportThemesOverview', className);
  const paragraph = entity.toJS();
  const themeId = paragraph.field_recent_content_type[0].entity.tid[0].value;

  return (
    <div className={classNames}>
      <View
        id="annual_report"
        display="all"
        args={[themeId]}
      />
    </div>
  );
};

export default ParagraphAnnualReportThemesOverview;
